import { template1 } from './nttd/template1';

export const templates_nttd = [template1];
